export const ONE_MINUTE_MS = 60_000;

export type SessionLifetimeResult =
  | { enabled: false; reason: 'missing' | 'non-finite' | 'non-positive' }
  | { enabled: true; timeoutMs: number; promptBeforeIdleMs: number };

function createSessionLifetime(timeoutMs: number): SessionLifetimeResult {
  return {
    enabled: true,
    timeoutMs,
    promptBeforeIdleMs: Math.min(ONE_MINUTE_MS, Math.max(0, timeoutMs - 1))
  };
}

export function parseSessionLifetime(
  value: unknown,
  timeoutSeconds?: unknown
): SessionLifetimeResult {
  const overrideSeconds =
    typeof timeoutSeconds === 'string' ? Number(timeoutSeconds) : timeoutSeconds;
  if (
    typeof overrideSeconds === 'number' &&
    Number.isFinite(overrideSeconds) &&
    overrideSeconds > 0
  ) {
    return createSessionLifetime(Math.min(Number.MAX_SAFE_INTEGER, overrideSeconds * 1_000));
  }
  if (typeof value !== 'number') return { enabled: false, reason: 'missing' };
  if (!Number.isFinite(value)) return { enabled: false, reason: 'non-finite' };
  if (value <= 0) return { enabled: false, reason: 'non-positive' };

  return createSessionLifetime(Math.min(Number.MAX_SAFE_INTEGER, value * ONE_MINUTE_MS));
}
